<template>
  <component :is="layout">
    <template v-for="name in slotNames" :key="name" #[name]>
      <slot :name />
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import CondensedProductDetailPageLayout from '~/scopes/product-core/components/containers/layouts/ContainerProductDetailPageLayout/components/CondensedProductDetailPageLayout/CondensedProductDetailPageLayout.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/containers/layouts/ContainerProductDetailPageLayout/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'

import type { ContainerProductDetailPageLayoutSlots } from './ContainerProductDetailPageLayout.types'

const slots = defineSlots<ContainerProductDetailPageLayoutSlots>()

const experiments = useExperiments()

const slotNames = Object.keys(
  slots,
) as (keyof ContainerProductDetailPageLayoutSlots)[]

const isCondensedFunnelEnabled = computed(
  () => experiments['experiment.ppCondensedFunnel'] === 'withCondensedFunnel',
)

const layout = computed(() =>
  isCondensedFunnelEnabled.value
    ? CondensedProductDetailPageLayout
    : ProductDetailPageLayout,
)
</script>
